// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "* {\n  margin: 0;\n  padding: 0;\n}\n.gm-style-iw-t button {\n  display: none !important;\n}\n.gm-style-iw-t::after {\n  height: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
